namespace $.$$ {
	$mol_style_define( $shm_hitalama_text_code, {
		Copy_button: {
			alignSelf: 'flex-start',
			justifySelf: 'flex-start',
		},
	} )
}
